import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";
import ServicesGrid from "../components/ServicesGrid";

export default function Services() {
  return (
    <main data-testid="page-services" className="pt-32 md:pt-40 bg-[#FCFCFA]">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
        <div className="grid md:grid-cols-12 gap-10">
          <ScrollReveal className="md:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline-gold" />
              <span className="overline">Our Services</span>
            </div>
            <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] text-[#1A1D20]">
              Integrated capabilities across six strategic sectors.
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.15} className="md:col-span-4 md:col-start-9 flex items-end">
            <p className="text-[#5C636A] text-[15px] md:text-[17px] leading-relaxed">
              From a new international airport and an International Financial
              Centre to world-class hotels, wellness resorts, smart-city
              infrastructure and sustainable energy — each of our service
              lines is engineered to reinforce the others, creating a whole
              greater than the sum of its parts.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <ServicesGrid title={false} />

      <section className="bg-[#1A1D20] text-[#FCFCFA] py-24 md:py-28" data-testid="services-cta">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-serif-display text-3xl md:text-5xl leading-tight">
            Looking to collaborate on a specific sector?
          </h2>
          <p className="mt-8 text-white/75 text-[15px] md:text-[17px] leading-relaxed">
            We partner with world-class firms across infrastructure, tourism,
            logistics, agriculture, energy and economic development. Let's
            start a conversation.
          </p>
          <Link
            to="/contact"
            data-testid="services-cta-contact"
            className="mt-10 inline-flex items-center bg-[#D4AF37] text-[#1A1D20] hover:bg-white transition-colors duration-300 px-8 py-4 uppercase tracking-[0.18em] text-[12px] font-semibold"
          >
            Start A Conversation
          </Link>
        </div>
      </section>
    </main>
  );
}
